import { extend } from "vee-validate";
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/it.json';
import { setInteractionMode } from 'vee-validate';

setInteractionMode('eager');
// import { size, image } from 'vee-validate/dist/rules';

Object.keys(rules).forEach(rule => {
    extend(rule, {
        ...rules[rule], // copies rule configuration
        message: messages[rule] // assign message
    });

    extend('true', value => {
        if (value == true) {
            return true;
        }

        return 'Accettare termini e condizioni';
    });
});
extend('required', value => {
    if (value) {
        return true;
    }

    return 'Il campo è obbligatorio';
});
extend('email', value => {
    if (value) {
        return true;
    }

    return 'Il campo è obbligatorio';
});
